import React from 'react';
import { Container, Typography, Box, Button, Breadcrumbs, Link } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { TermsContent } from '../components/TermsContent';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          variant="outlined"
          sx={{ mb: { xs: 1, sm: 0 } }}
        >
          Back
        </Button>
        <Breadcrumbs aria-label="breadcrumb">
          <Link
            color="inherit"
            component="button"
            onClick={() => navigate('/')}
            underline="hover"
            sx={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
          >
            Home
          </Link>
          <Typography color="text.primary">Terms of Service</Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ maxWidth: '800px' }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 4, color: 'text.secondary' }}>
          Effective Date: 15 February 2025
        </Typography>
        <TermsContent />
      </Box>
    </Container>
  );
};

export default Terms;
